// Full-document render of the pillows ProductDisplayPage: PageSkeleton (the
// React document shell) wrapping the PDP hero (PDPHero island + configurator)
// and the consolidated body island, in the same order as the legacy
// product_display_page.html layout block.
import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductDisplayPageBody } from "../components/ProductDisplayPageBody";
import { Template as ModularConfigurator } from "./ModularConfiguratorTemplate";
import { Template as PDPHero } from "./PDPHeroTemplate";

// Mutable reactivated props (not Immutable<>): PageSkeleton composes the in-tree
// SiteHeader chain, which is typed with mutable reactivated props.
export const Template = (
    props: templates.ProductDisplayPageTemplate,
): React.JSX.Element => {
    const { page, hero, configurator, reviews, iovation_url } = props;
    const chrome = React.useContext(Context).chrome;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div id="product-detail-container">
                <div id="product-detail">
                    <div className="pdp-hero">
                        <PDPHero {...hero} />
                        <div className="pdp-hero__content l-capped-width">
                            <ModularConfigurator {...configurator} />
                        </div>
                    </div>
                </div>
            </div>
            <ProductDisplayPageBody page={page} reviews={reviews} />
            <IovationScripts
                iovationUrl={iovation_url}
                staticBase={chrome.static_base}
            />
        </PageSkeleton>
    );
};
